import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';
import ApiService from '../utils/apiService';

Vue.use(Vuex);



export default new Vuex.Store({
  state: {
    account: null,  // 用户信息
    student: null,
    isLoggedIn: false, // 登录状态
    isStudentBound: false,  // 学员绑定状态
    competitionUser:JSON.parse(localStorage.getItem('competitionUser')) || null,

  },
  mutations: {
    SET_COMPETITION_USER(state, user) {
      state.competitionUser = user;
      localStorage.setItem('competitionUser', JSON.stringify(user));
    },
    SET_USER(state, user) {
      state.account = user.account;
      state.student = user.student;
      state.isLoggedIn = !!user.account;  // 设置登录状态 
      state.isStudentBound = !!user.student;  // 设置学员绑定状态
    },
    SET_USER_AVATAR(state, avatar) {
      if (state.account) {
        Vue.set(state.account, "avatar", avatar); 
      }
    },
    LOGOUT(state) {
      state.account = null;
      state.student = null;
      state.isLoggedIn = false;
      state.isStudentBound = false;
    }
  },
  actions: {
    // 登录并保存用户信息到本地存储
    login({ commit }, user) {
      commit('SET_USER', user);
    },
    logout({ commit }) {
      // 清除 Cookie 中的 Token
      Cookies.remove('user_token');
      // 清除 Vuex 中的用户信息
      commit('LOGOUT');
    },
    setAvatar({ commit }, avatar) {
      commit('SET_USER_AVATAR', avatar);
    },
    async fetchUserInfo({ commit }) {
      const token = Cookies.get('user_token');
      if (token) {
        try {
          const response = await ApiService.post('/api/user/GetUserInfo', null, null, { noLoading: 1 });
          if (response.statecode == 0) {
            Cookies.set('user_token', response.data.token, { expires: 1 });
            commit('SET_USER', response.data.userInfo);
          }

        } catch (error) { console.error(error) }
      }
    },
    setCompetitionUser({ commit }, user) {
      commit('SET_COMPETITION_USER', user);
    },
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    isStudentBound: state => state.isStudentBound,
    account: state => state.account,
    student: state => state.student,
    competitionUser:state => state.competitionUser,
  }
});